import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  MAILING_STATUS,
  REQUEST_STATUS,
} from '../../../../shared/api/hscan/hospital';
import {
  GreenStatusMessage,
  BlueStatusMessage,
  RedStatusMessage,
  Message,
  GreyStatusMessage,
} from '../../common/components/styledComponents';

interface StatusMessageProps {
  status: REQUEST_STATUS | MAILING_STATUS;
  onClick?(): void;
}
/**
 * 신청가능: available (G)
 * 신청완료: pending (G)
 * 발급완료: completed (B)
 * 발급거절: declined (R)
 * 발급취소: requestCancelled (R)
 * 발송취소: orderMailCancelled (g)
 * 발송예정: waitForMail (g)
 * 발송완료: mailed (B)
 */
export const StatusMessage = (props: StatusMessageProps) => {
  const { status, onClick } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.requestedImages.table.statusMessage',
  });

  switch (status) {
    case 'AVAILABLE':
      return (
        <GreenStatusMessage onClick={onClick}>{`${t(
          'available',
        )}`}</GreenStatusMessage>
      );
    case 'PENDING':
      return (
        <GreenStatusMessage onClick={onClick}>{`${t(
          'pending',
        )}`}</GreenStatusMessage>
      );
    case 'DECLINED':
      return (
        <RedStatusMessage onClick={onClick}>{`${t(
          'declined',
        )}`}</RedStatusMessage>
      );
    case 'CANCELLED':
      return (
        <RedStatusMessage onClick={onClick}>{`${t(
          'requestCancelled',
        )}`}</RedStatusMessage>
      );
    case 'COMPLETED':
      return (
        <BlueStatusMessage onClick={onClick}>{`${t(
          'completed',
        )}`}</BlueStatusMessage>
      );
    case 'FAILED':
      return (
        <RedStatusMessage onClick={onClick}>{`${t(
          'failed',
        )}`}</RedStatusMessage>
      );
    case 'ORDER_PENDING':
      return (
        <GreenStatusMessage onClick={onClick}>{`${t(
          'orderPending',
        )}`}</GreenStatusMessage>
      );
    case 'ORDER_MAILED':
      return (
        <GreenStatusMessage onClick={onClick}>{`${t(
          'orderMailed',
        )}`}</GreenStatusMessage>
      );
    case 'ORDER_ONLINE_DONE':
      return (
        <GreyStatusMessage onClick={onClick}>
          {`${t('orderOnlineDone')}`}
        </GreyStatusMessage>
      );
    case 'ORDER_MAIL_CANCELLED':
      return (
        <GreyStatusMessage onClick={onClick}>{`${t(
          'orderMailCancelled',
        )}`}</GreyStatusMessage>
      );
    default:
      return <Message>{status}</Message>;
  }
};
